import { getApiVersion, http } from '../utils/domain'
import { stringifyQuery } from '../utils/query'

/**
 * 获取报告生成队列分页数据
 * @param params
 *   id	任务id
 *   taskType 任务类型：下载器生成、excel生成、word生成
 *   appId
 *   page 起始页默认0
 *   per	单页大小默认10
 * @returns
 */
export const fetchDownloadList = (params) => {
  return http()
    .get(
      `${getApiVersion()}/dynamic_report/fetchGenerateTaskPage${stringifyQuery(
        params
      )}`
    )
    .json()
}

/**
 * 编辑报告生成任务
 * @param {*} params
 *   id: 任务id
 *   state: 任务状态
 *     WAITING 等待获取中
 *     RUNNING 生成中
 *     CANCEL 已取消
 *     READY 已完成
 *     TIMEOUT 已超时回滚
 *     NOT_SUPPORT 不支持的模式
 * @returns
 */
export const editDownloadTask = (params) => {
  return http()
    .put(`${getApiVersion()}/dynamic_report/generateTask`, params)
    .json()
}

/**
 * 批量删除生成任务
 * @param {string[]} ids 任务id list
 * @returns
 */
export const destoryDownloadTask = (ids) => {
  return http()
    .delete(`${getApiVersion()}/dynamic_report/generateTask`, ids)
    .json()
}

/**
 * 获取任务结果
 * @param {string} id
 * @returns
 */
export const getTaskResult = (id) => {
  return http()
    .get(`${getApiVersion()}/dynamic_report/generateTaskResults/${id}`)
    .json()
}

/**
 * 获取下载器信息
 * @returns
 */
export const getDownloaderFiles = (appId) => {
  return http()
    .get(`${getApiVersion()}/apps/${appId}/globalFile/fetchDownloaderFiles`)
    .json()
}
